<template>
  <div>
    <a-spin :spinning="iLoading">
      <template v-for="action in actions">
        <a-button :type="action.btn_type" :loading="iLoading" style="margin-right: 5px; margin-bottom: 5px;"
                  :icon="action.btn_icon"
                  @click="handleAction(action)">
          {{action.label}}
        </a-button>
      </template>
    </a-spin>
  </div>
</template>
<script>
  import HttpUtil from '@/util/HttpUtil'
  import JsUtils from '@/util/JsUtils'
  import Mensajes from '../../Util/Mensajes'

  const btnTypes = {
    PL: 'PL',
    PHP: 'PHP',
    JS: 'JS'
  }

  export default {
    data () {
      return {
        iLoading: false,
        actions: [],
        selectedAction: {}
      }
    },
    /*
    * preValidate: funcion utilizada para indicar si el boton puede o no disparar la acción. Ej. Validar un formulario antes de enviar la acción. Si retorna true se manda.
    */
    props: ['group', 'loading', 'params', 'preValidate'],
    mounted () {
      this.httpClient = new HttpUtil()

      if (!JsUtils.isEmpty(this.group)) {
        this.loadActions()
      }
    },
    methods: {
      loadActions () {
        this.iLoading = true
        this.httpClient.getInstance().get('action_groups/acciones_disponibles', {params: {group: this.group}}).then(response => {
          this.actions = response.data
        }).catch(this.manejaError).then(() => {
          this.iLoading = false
        })
      },
      handleAction (action) {
        let continuar = true
        if (!JsUtils.isEmpty(this.preValidate) && this.preValidate instanceof Function) {
          continuar = this.preValidate()
        }
        if (!continuar) return
        if (action.confirm) {
          this.$confirm({
            title: 'Confirmación',
            content: action.confirm_message || '¿Está seguro que desea realizar esta acción?',
            onOk: () => {
              return new Promise((resolve, reject) => {
                this.runAction(action, resolve, reject)
              })
            },
            onCancel () {}
          })
        } else {
          this.runAction(action)
        }
      },
      runAction (action, resolve, reject) {
        switch (action.action_type) {
          case btnTypes.JS:
            this.$emit('action', action)
            setTimeout(() => {
              resolve && resolve()
            }, 150)
            break
          default:
            this.iLoading = true
            this.httpClient.getInstance().post(`action_groups/ejecutar_accion/${action.id}`, this.params || {}, {responseType: 'arraybuffer'})
              .then((response) => {
                Mensajes.success('Correcto', response.data.message || 'Proceso ejecutado satisfactoriamente')
                this.$emit('success', response)

                if (action.use_download) {
                  this.downloadFile(response)
                }

                resolve && resolve()
              })
              .catch((error) => {
                this.manejaError(error)
                this.$emit('error', error)
                reject && reject()
              })
              .then(() => {
                this.iLoading = false
              })
            break
        }
      },
      manejaError (error) {
        Mensajes.error(this.$getErrorMessage(error, 'Error inesperado. Consulte al administrador.'))
      },
      downloadFile (response) {
        let fileURL = new Blob([response.data], {type: 'application/octet-stream'})
        fileURL = window.URL.createObjectURL(fileURL)
        let fileLink = document.getElementById('file_link_elm')
        if (fileLink === null) {
          fileLink = document.createElement('a')
          fileLink.setAttribute('id', 'file_link_elm')
          document.body.appendChild(fileLink)
        }

        fileLink.setAttribute('href', fileURL)
        fileLink.setAttribute('download', response.headers['x-nombre-archivo'])
        fileLink.click()
      }
    },
    watch: {
      iLoading () {
        if (this.iLoading !== this.loading) {
          this.$emit('update:loading', this.iLoading)
        }
      },
      loading () {
        if (this.iLoading !== this.loading) {
          this.iLoading = this.loading
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/components/ActionGroups/ActionGroup.vue